<template>
  <div class="container">
    <div class="ui grid stackable">
      <div class="twelve wide column">
        <h1>Email Messages</h1>
      </div>
      <listing-buttons :name="btnName" :route="route"></listing-buttons>
    </div>

    <div class="ui divider"></div>

    <div id="table">
      <vuetable
        ref="vuetable"
        :api-url="apiUrl"
        :fields="fields"
        :data="emails"
        pagination-path
        :per-page="25"
        :multi-sort="true"
        :sort-order="sortOrder"
        :append-params="moreParams"
        @vuetable:pagination-data="onPaginationData"
        :http-options="httpOptions"
      >
        <template slot="actions" slot-scope="props">
          <div class="table-button-container modal-container">
            <button class="ui button" @click="goToDetail(props)">
              <i class="fa fa-edit" title="edit"></i></button
            >&nbsp;&nbsp;
            <button
              class="ui button primary"
              @click="previewRow(props.rowData)"
            >
              <i class="fa fa-binoculars" title="preview"></i></button
            >&nbsp;&nbsp;
          </div>
        </template>
      </vuetable>

      <vuetable-pagination
        ref="pagination"
        @vuetable-pagination:change-page="onChangePage"
      ></vuetable-pagination>
    </div>

    <semantic-modal
      medium
      flip
      vertical
      :active.sync="showModal"
      :data="emailData"
      class="email-preview"
    >
      <div class="header">Email Preview: {{ emailData.subject }}</div>
      <div class="row">
        <div class="ui header">From:</div>
        <span>{{ emailData.from }}</span>
      </div>

      <div class="row">
        <div class="ui header">CC:</div>
        <span>{{ emailData.cc }}</span>
      </div>

      <div class="row">
        <div class="ui header">BCC:</div>
        <span>{{ emailData.bcc }}</span>
      </div>

      <div class="row">
        <div class="ui header">Subject:</div>
        <span>{{ emailData.subject }}</span>
      </div>
      <div class="row">
        <div class="ui header">Email Content<br /></div>
      </div>
      <div class="row">
        <div v-html="emailData.content"></div>
      </div>
      <div class="actions">
        <button
          class="ui button primary"
          @click="goToEmailDetail(emailData.id)"
        >
          Edit
        </button>
        <button class="ui button" @click="showModal = false">Close</button>
      </div>
    </semantic-modal>
  </div>
</template>

<script>
import Vue from "vue";
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import SemanticModal from "vue-ya-semantic-modal";
import APIService from "@/assets/js/APIService";
const apiService = new APIService();
import httpClient from "@/assets/js/HttpClient";

export default {
  name: "Machines",
  computed: {},
  components: {
    Vuetable,
    VuetablePagination,
    SemanticModal: SemanticModal(),
  },
  data() {
    return {
      btnName: "Email",
      route: "Edit Email Messages",
      showModal: false,
      id: "",
      fields: [
        {
          name: "subject",
          title: "Email Subject Name",
        },
        {
          name: "from",
          title: "From",
        },
        "__slot:actions",
      ],
      sortOrder: [
        {
          field: "email",
          sortField: "email",
          direction: "desc",
        },
      ],
      moreParams: {},
      apiUrl: apiService.getEmailsUrl(),
      httpOptions: {
        headers: httpClient.defaults.headers,
      },
      open: false,
      emails: [],
      emailData: [],
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", () => this.onFilterReset());
    this.getEmail();
  },
  methods: {
    getEmail() {
      apiService.getEmails().then((data) => {
        this.emails = data;
      });
    },
    goToEmailDetail(emailData) {
      this.$router.push({
        name: "Edit Email Messages",
        params: {
          id: emailData,
        },
      });
    },
    goToDetail(props) {
      this.$router.push({
        name: "Edit Email Messages",
        params: {
          id: props.rowData.id,
        },
      });
    },
    previewRow(email) {
      this.showModal = !this.showModal;
      this.emailData = email;
    },
    emailSuccessful(request) {
      (this.From = request.From),
        (this.Cc = request.Cc),
        (this.Bcc = request.Bcc),
        (this.Subject = request.Subject),
        (this.Content = request.Content);
    },
    emailFailed(err) {
      this.$bvToast.toast("TraceID: " + err.error.response.data.traceId, {
        title: err.error.response.data.title,
        autoHideDelay: 10000,
        appendToast: false,
        variant: "danger",
        solid: true,
      });
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onFilterSet(filterText) {
      this.moreParams.filter = filterText;
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
    onFilterReset() {
      delete this.moreParams.filter;
      Vue.nextTick(() => this.$refs.vuetable.refresh());
    },
  },
};
</script>

<style module></style>
